var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGradientBackgroundWave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 800 400",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    gradientUnits: "userSpaceOnUse",
    cx: 624.393,
    cy: 545.325,
    r: 649.942,
    id: "gradient-1",
    gradientTransform: "matrix(1.604582, -0.125374, 0.077898, 0.996961, -495.698002, 100.39529)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(146, 30, 195)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(51, 13, 92)"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    gradientUnits: "userSpaceOnUse",
    cx: 518.593,
    cy: 317.751,
    r: 649.942,
    id: "gradient-2",
    gradientTransform: "matrix(1.604582, -0.125374, 0.077898, 0.996961, -296.862457, 74.664557)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(146, 30, 195)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(51, 13, 92)"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M 391.265 153.03 C 637.251 157.114 606.294 -54.241 849.144 97.334 C 1103.331 255.985 1160.664 -139.527 1058.666 254.509 C 1007.2 453.333 899.952 416.856 730.607 359.204 C 544.685 295.909 -238.639 439.705 -152.897 201.956 C -14.876 -180.755 144.004 148.925 391.265 153.03 Z",
    style: {
      stroke: "rgb(129, 151, 57)",
      strokeWidth: 0,
      fill: "url(#gradient-1)",
      fillOpacity: 0.97
    },
    stroke: "rgb(255,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 347.284 73.51 C 531.797 103.72 615.876 225.559 872.783 99.265 C 1134.654 -29.469 1359.5 -165.258 1257.502 228.778 C 1206.036 427.602 1075.933 252.302 794.203 325.789 C 525.953 395.76 311.987 404.014 90.507 282.265 C -46.563 206.917 103.238 33.553 347.284 73.51 Z",
    style: {
      stroke: "rgb(129, 151, 57)",
      strokeWidth: 0,
      fillOpacity: 0.97,
      fill: "url(#gradient-2)"
    },
    stroke: "rgb(255,0,0)"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradientBackgroundWave);
export default __webpack_public_path__ + "static/media/gradient-background-wave.e91516c3ee63276c19c7ea8a37df970d.svg";
export { ForwardRef as ReactComponent };